import { library } from './library';

export const webPlayer = {
  library,
};
